import React, { useState } from "react"

import { ModalConfirm } from "@/components/common/element/ModalConfirm"

import type { ICompanyBank } from "@/types/company/IFullCompanyDto"
import type { IModalMessage } from "@/types/error/IModalMessage"

export const BankTableItem: React.FC<{
  bank: ICompanyBank
  onRemove: (bankId: number) => void
  refetch: () => void
}> = ({ bank }) => {
  const [modalConfirm, setModalConfirm] = useState<IModalMessage>()

  return (
    <>
      <ModalConfirm message={modalConfirm} setMessage={setModalConfirm} />
      <li className="global-item">
        <p className={`global-item-text global-name cols-4`}>{bank.name}</p>
        <p className="global-item-text global-bank cols-4">{bank.swift}</p>
        <p className="global-item-text globak-swift cols-4">{bank.accountNumber}</p>
        <p className="global-item-text globak-num cols-4">{bank.currency}</p>
      </li>
    </>
  )
}
